import React from "react";
import svg163 from "../../../../assets/svg/svg163.svg";
import svg165 from "../../../../assets/svg/svg165.svg";
import svg152 from "../../../../assets/svg/svg152.svg";

function PaymentSummary({ accountNumber,company }) {
  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] ">
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-[0.75rem]">
          <div className="flex items-center gap-[0.5rem]">
            <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-ink flex items-center justify-center">
              <img src={svg163} alt="svg163" />
            </div>
            <span className="text-ink font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
              Water & Sanitation Payment
            </span>
          </div>

          <div className="flex lg:flex-row flex-col lg:items-center gap-[.5rem]">
            <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-surface2 w-fit">
              <img
                src={svg165}
                alt="svg165"
                className="w-[0.75rem] h-[0.75rem]"
              />
              <span className="text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
                {accountNumber || "N/A"}
              </span>
            </div>

            <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-surface2 w-fit">
              <img
                src={svg152}
                alt="svg152"
                className="w-[0.75rem] h-[0.75rem]"
              />
              <span className="text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
                {company?.pbName || "N/A"}
              </span>
            </div>
          </div>
        </div>

        <div className="py-[0.125rem] px-[0.5rem] rounded-[624.9375rem] bg-surface2 text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
          Preview
        </div>
      </div>
    </div>
  );
}

export default PaymentSummary;
